import React, { useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RestService from '../Services/RestService';
import OKomLoading from '../Components/OsloKommuneUI/OKomLoading';

const EXCLUDED_EVENT_READABLE_IDS = new Set<string>(['stafett_100_x_4', 'kulai_eduthal']);

const AGE_BANDS: { ages: number[]; background: string }[] = [
  { ages: [4, 5, 6],                 background: '#f5b7c0' },
  { ages: [7, 8, 9, 10],             background: '#f5d7dc' },
  { ages: [11, 12, 13],              background: '#bfdff0' },
  { ages: [14, 15, 16, 17, 18],      background: '#f6d2a3' },
];

const backgroundForAge = (age: number): string => {
  for (const band of AGE_BANDS) {
    if (band.ages.includes(age)) return band.background;
  }
  return '#fff';
};

const AthleticsEventsMatrixView: React.FC<RouteComponentProps> = () => {
  const [events, setEvents] = useState<Api.AthleticsEventDto[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    document.title = 'Øvelser per aldersgruppe — Annaipoopathi';
    (async () => {
      try {
        const res = await RestService.get<Api.AthleticsEventDto[]>(`/api/athleticsregistration/GetEvents?year=${new Date().getFullYear()}`);
        setEvents((res ?? []).filter(e => !EXCLUDED_EVENT_READABLE_IDS.has(e.ReadableId)));
      } catch (e) {
        toast.error('Kunne ikke laste øvelser');
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const ages = Array.from({ length: 15 }, (_, i) => i + 4);
  const currentYear = new Date().getFullYear();
  const cellStyle: React.CSSProperties = { border: '1px solid #888', padding: '8px 6px', textAlign: 'center', fontSize: '.9rem', wordBreak: 'break-word' };
  const headStyle: React.CSSProperties = { ...cellStyle, background: '#eee', whiteSpace: 'normal' };
  const rowHeadStyle: React.CSSProperties = { ...cellStyle, background: '#eee', fontWeight: 600 };

  return (
    <>
      {isLoading && <OKomLoading text="Laster..." />}
      <div className="ods-margin-top-25 ods-grid ods-grid--gap ods-grid--center" style={{ maxWidth: '95rem' }}>
        <div className="ods-grid__column--12 ods-text--align-center">
          <h2>Øvelser per aldersgruppe / விளையாட்டுப்போட்டிகள் மற்றும் பிரிவுகள்</h2>
        </div>
        <div className="ods-grid__column--12">
          <table style={{ borderCollapse: 'collapse', margin: '0 auto', background: '#fff', tableLayout: 'fixed', width: '100%' }}>
            <thead>
              <tr>
                <th style={headStyle}>Fødselsår<br/>பிறந்த ஆண்டு</th>
                <th style={headStyle}>Aldersgruppe<br/>வயது</th>
                {events.map(e => (
                  <th key={e.Id} style={headStyle}>
                    <div>{e.NameNo}</div>
                    <div style={{ fontWeight: 400, fontSize: '.875rem' }}>{e.NameTa}</div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {ages.map(a => {
                const bg = backgroundForAge(a);
                return (
                  <tr key={a} style={{ background: bg }}>
                    <th style={{ ...rowHeadStyle, background: bg }}>{currentYear - a}</th>
                    <th style={{ ...rowHeadStyle, background: bg }}>{a}</th>
                    {events.map(e => (
                      <td key={e.Id} style={cellStyle}>{e.Ages.includes(a) ? 'X' : ''}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default withRouter(AthleticsEventsMatrixView);
